import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
// import "./DisplayOfflineReader.css";

const DisplayOfflineReader = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [contents, setContents] = useState([]);
 

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDetails, setOpenDetails] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedContent, setSelectedContent] = useState(null);
  const [formData, setFormData] = useState({});

  // ================= SEARCH =================
  const [search, setSearch] = useState("");
  const [openAdd, setOpenAdd] = useState(false);

const [addFormData, setAddFormData] = useState({
  title: "",
  content: "",
});

  // ================= FETCH ALL =================
  useEffect(() => {
    fetchContents();
  }, []);

  const fetchContents = async () => {
    try {
      const response = await fetch(
        `${API_URL}/reader/contents`
      );

      const result = await response.json();

      setContents(result.data?.items || result.data || []);
    } catch (error) {
      console.error("Error fetching contents:", error);
    }
  };

   const fetchContents1 = async () => {
    try {
      const response = await fetch(
        `${API_URL}/reader/contents`
      );

      const result = await response.json();

      setContents(result.data?.items || result.data || []);
    } catch (error) {
      console.error("Error fetching contents:", error);
    }
  };

  // ================= SEARCH =================
  const handleSearch = async (value) => {
    setSearch(value);

    try {
      const response = await fetch(
        `${API_URL}/reader/contents?search=${value}`
      );

      const result = await response.json();

      setContents(result.data?.items || result.data || []);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  // ================= PAGINATION =================

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ================= OPEN DIALOGS =================

  // const handleOpenDetails = (content) => {
  //   setSelectedContent(content);
  //   setOpenDetails(true);
  // };
  const handleOpenDetails = async (content) => {
  try {
    const response = await fetch(
      `${API_URL}/reader/contents/${content.id}`
    );

    const result = await response.json();

    if(response.ok){
      setSelectedContent(result.data);
      setOpenDetails(true);
    }

  } catch(error){
    console.error("Details error:", error);
  }
};

  // const handleOpenEdit = (content) => {
  //   setSelectedContent(content);
  //   setFormData(content);
  //   setOpenEdit(true);
  // };
  const handleOpenEdit = async (content) => {
  try {
    console.log("Opening edit for ID:", content.id);

    const response = await fetch(
      `${API_URL}/reader/contents/${content.id}`
    );

    const result = await response.json();

    console.log("Edit details response:", result);

    if (response.ok) {
      setSelectedContent(result.data);
      setFormData({
        id: result.data.id,
        title: result.data.title,
        content: result.data.content,
      });

      setOpenEdit(true);
    } else {
      console.error("Failed loading content:", result.message);
    }

  } catch (error) {
    console.error("Edit load error:", error);
  }
};

  const handleOpenDelete = (content) => {
    setSelectedContent(content);
    setOpenDelete(true);
  };

  const handleCloseDialogs = () => {
    setOpenDetails(false);
    setOpenEdit(false);
    setOpenDelete(false);
    setSelectedContent(null);
    setFormData({});
  };

  // ================= INPUT CHANGE =================

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleAddInputChange = (e) => {
  setAddFormData({
    ...addFormData,
    [e.target.name]: e.target.value,
  });
};

// ================= CREATE =================

const handleCreate = async () => {
  try {

    console.log("Creating content:", addFormData);

    const response = await fetch(
      `${API_URL}/reader/contents`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addFormData),
      }
    );


    const result = await response.json();

    console.log("Create response:", result);


    if(response.ok){

      await fetchContents();

      setAddFormData({
        title:"",
        content:"",
      });

      setOpenAdd(false);

    }else{

      console.error(result.message);

    }


  } catch(error){

    console.error(
      "Create error:",
      error
    );

  }
};

  // ================= UPDATE =================

  const handleUpdate = async () => {
    try {
      const response = await fetch(
        `${API_URL}/reader/contents/${selectedContent.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        fetchContents();
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.error("Update error:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  // ================= DELETE =================

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `${API_URL}/reader/contents/${selectedContent.id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setContents((prev) =>
          prev.filter((c) => c.id !== selectedContent.id)
        );
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  return (
    <>
      <div className="search-box">
        {/* ================= SEARCH ================= */}

        <TextField
          fullWidth
          label="Search content..."
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
  variant="contained"
  color="success"
  sx={{ mb: 2 }}
  onClick={() => setOpenAdd(true)}
>
  Add Content
</Button>
      </div>

      {/* ================= TABLE ================= */}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Content</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {contents
              .slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              .map((content) => (
                <TableRow key={content.id}>
                  <TableCell>{content.id}</TableCell>

                  <TableCell>{content.title}</TableCell>

                  <TableCell>
                    {content.content}
                  </TableCell>

                  <TableCell
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() =>
                        handleOpenEdit(content)
                      }
                    >
                      Edit
                    </Button>

                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() =>
                        handleOpenDelete(content)
                      }
                    >
                      Delete
                    </Button>

                    <Button
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={() =>
                        handleOpenDetails(content)
                      }
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[10, 25]}
          component="div"
          count={contents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={
            handleRowsPerPageChange
          }
        />
      </TableContainer>


      {/* ================= ADD ================= */}

<Dialog
  open={openAdd}
  onClose={() => setOpenAdd(false)}
  maxWidth="md"
  fullWidth
>

<DialogTitle>
  Add Content
</DialogTitle>


<DialogContent>


<TextField
  label="Title"
  name="title"
  value={addFormData.title}
  onChange={handleAddInputChange}
  fullWidth
  margin="dense"
/>


<TextField
  label="Content"
  name="content"
  value={addFormData.content}
  onChange={handleAddInputChange}
  fullWidth
  multiline
  rows={12}
  margin="dense"
/>


</DialogContent>


<DialogActions>

<Button
 onClick={()=>{
   setOpenAdd(false);
 }}
 color="secondary"
>
 Cancel
</Button>


<Button
 onClick={handleCreate}
 color="success"
>
 Save
</Button>


</DialogActions>


</Dialog>

      {/* ================= DETAILS ================= */}

      <Dialog
        open={openDetails}
        onClose={handleCloseDialogs}
      >
        <DialogTitle>Content Details</DialogTitle>

        <DialogContent>
          <Typography>
            <b>ID:</b> {selectedContent?.id}
          </Typography>

          <Typography>
            <b>Title:</b> {selectedContent?.title}
          </Typography>

          <Typography sx={{ mt: 2 }}>
            <b>Content:</b>
          </Typography>

          <Typography whiteSpace="pre-wrap">
            {selectedContent?.content}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialogs}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= EDIT ================= */}

      <Dialog
        open={openEdit}
        onClose={handleCloseDialogs}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Edit Content</DialogTitle>

        <DialogContent>
          <TextField
            label="Title"
            name="title"
            value={formData.title || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />

          <TextField
            label="Content"
            name="content"
            value={formData.content || ""}
            onChange={handleInputChange}
            fullWidth
            multiline
            rows={12}
            margin="dense"
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseDialogs}
            color="secondary"
          >
            Cancel
          </Button>

          <Button
            onClick={handleUpdate}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= DELETE ================= */}

      <Dialog
        open={openDelete}
        onClose={handleCloseDialogs}
      >
        <DialogTitle>Delete Content</DialogTitle>

        <DialogContent>
          Are you sure you want to delete{" "}
          <b>{selectedContent?.title}</b>?
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialogs}>
            Cancel
          </Button>

          <Button
            onClick={handleDelete}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayOfflineReader;




{/* <TextField
  label="Content"
  name="content"
  value={formData.content || ""}
  onChange={handleInputChange}
  fullWidth
  multiline
  rows={12}
  margin="dense"
/> */}

{/* <Typography>
  Debug: {JSON.stringify(formData)}
</Typography> */}